"use strict";
/**
 * CONNOX GMBH CONFIDENTIAL
 * ________________________
 *
 * Copyright (c) 2005 - 2020 Connox GmbH, All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property
 * of Connox GmbH and its suppliers, if any. The intellectual and
 * technical concepts contained herein are proprietary to Connox GmbH and
 * its suppliers and may be covered by German Laws and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is
 * strictly forbidden unless prior written permission is obtained from
 * Connox GmbH.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CartPosition = void 0;
const CartItem_1 = require("./CartItem");
const CartItemAvailability_1 = require("./CartItemAvailability");
const CartItemDiscountability_1 = require("./CartItemDiscountability");
const CartMessage_1 = require("./CartMessage");
const Money_1 = require("./Money");
const Tax_1 = require("./Tax");
class CartPosition {
    constructor(rawData) {
        this.amount = new Money_1.Money(rawData.amount);
        this.amountRetail = rawData.amountRetail ? new Money_1.Money(rawData.amountRetail) : null;
        this.isAllowedForDeliveryCountry = rawData.isAllowedForDeliveryCountry;
        this.availability = new CartItemAvailability_1.CartItemAvailability(rawData.availability);
        this.discountability = new CartItemDiscountability_1.CartItemDiscountability(rawData.discountability);
        if (rawData.item) {
            this.item = new CartItem_1.CartItem(rawData.item);
        }
        this.bundleItems = rawData.bundleItems;
        this.messages = [];
        if (rawData.messages) {
            for (const messageData of rawData.messages) {
                this.messages.push(new CartMessage_1.CartMessage(messageData));
            }
        }
        this.position = rawData.position;
        this.price = new Money_1.Money(rawData.price);
        this.priceRetail = rawData.priceRetail ? new Money_1.Money(rawData.priceRetail) : null;
        this.quantity = rawData.quantity;
        this.isValid = rawData.isValid;
        this.discountability = rawData.discountability;
        if (rawData.reference) {
            this.reference = rawData.reference;
        }
        else {
            throw new Error("no reference in CartPosition: " + this.position);
        }
        this.tax = new Tax_1.Tax(rawData.tax);
        this.text = rawData.text;
        this.type = rawData.type;
    }
}
exports.CartPosition = CartPosition;
